export default "__VITE_ASSET__DPfkHGzI__"